module.exports = __webpack_public_path__ + "static/pixel-287aea26079248fc0ed3a7049d89265a.gif";